<template>
  <div class="p-10 text-center md:flex md:text-left">
    <div class="md:w-1/4">
      <graphic-base width="98" height="97" viewBox="0 0 98 97">
        <circle-notifications />
      </graphic-base>
    </div>
    <div class="md:w-3/4">
      <h1 class="text-bold text-3xl text-zt-primary-100 mb-4  md:mb-3">
        <!-- {{ modalContent.title }} -->
      </h1>
      <div class="text-left">
        <p class="text-lg text-zt-dark-500" v-html="modalContent.body"></p>
      </div>
    </div>
  </div>
</template>

<script>
import GraphicBase from '@/components/commons/Illustrations/graphicBase.vue'
import CircleNotifications from '@/components/commons/Illustrations/graphicSVG/circleNotifications.vue'

export default {
  components: {
    GraphicBase,
    CircleNotifications
  },
  props: {
    modalContent: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  computed: {}
}
</script>
